import { loader } from 'graphql.macro';

export const CLIENT_STATE = loader('./getClientState.gql');
export const SET_CLIENT_STATE = loader('./setClientState.gql');
export const GENERAL_SETTINGS = loader('./generalSettings.gql');
export const LAST_SYNC_DATE = loader('./lastSyncDate.gql');
export const PAGE_DATA = loader('./pageData.gql');
export const PAGE_LIST = loader('./pageList.gql');
export const PREVIEW_INFO = loader('./previewInfo.gql');
export const SYNC_PAGE_DATA = loader('./syncPageData.gql');
export const PUBLISH_DATA = loader('./publishData.gql');
export const PREVIEW_PAGE_DATA = loader('./previewPageData.gql');
export const CREATE_PREVIEW_DATA = loader('./createPreviewData.gql');
export const CREATE_PUBLISH_DATA = loader('./createPublishData.gql');
export const CREATE_UNPUBLISH_DATA = loader('./createUnpublishData.gql');
export const REMOVE_SYNC_DATA = loader('./removeSyncData.gql');
export const UPDATE_GENERAL_SETTINGS = loader('./updateGeneralSettings.gql');
export const UPDATE_PAGE_DATA = loader('./updatePageData.gql');
export const UPDATE_SYNC_PAGE_DATA = loader('./updateSyncPageData.gql');
export const PAGE_VIEW = loader('./pageView.gql');
